import React from 'react';
import { Navigate } from 'react-router-dom';
import { SubscriptionFlowContainer } from '@features/subscriptions';
import { Box } from '@mui/material';

import { Lockout } from '../components/Lockout';

interface LockedOutContentProps {
  paymentStatus: string;
  userEmail: string;
  isExcepted: boolean;
  children: React.ReactNode;
}

/**
 * Component that handles locked_out user content rendering.
 * This component is rendered inside StatsigUserGate, ensuring that
 * useFeatureGate is called after user sync completes.
 */
export const LockedOutContent: React.FC<LockedOutContentProps> = ({
  paymentStatus,
  userEmail,
  isExcepted,
  children,
}) => {
  if (isExcepted) {
    return <>{children}</>;
  }

  if (paymentStatus === 'unpaid' || paymentStatus === 'canceled') {
    return <Navigate to="/practice/subscriptions" replace />;
  }

  if (paymentStatus === 'paused') {
    return <SubscriptionFlowContainer />;
  }

  // Other lockout statuses show the standard lockout content.
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Box sx={{ width: '70%' }}>
        <Lockout user_email={userEmail} payment_status={paymentStatus} />
      </Box>
    </Box>
  );
};
